/* ============
 * Deal Transformer
 * ============
 *
 * The transformer for the deal.
 */

import contentful from '@/app/plugins/contentful'
import Transformer from './Transformer'

// eslint-disable-next-line no-unused-vars
function getContentfulImages (images) {
  return Promise.all(images
    .map(img => contentful.getAsset(img.id)))
    .then(res =>
      res.map(asset => {
        return {
          url: asset.fields.file.url,
          title: asset.fields.title
        }
      })
    ).catch(err => {
      console.log(err)
      return {
        url: 'http://via.placeholder.com/350x250?text=Not+Found',
        title: 'Not found'
      }
    })
}

export default class DealTransformer extends Transformer {
  static async fetch (item) {
    return {
      id: item['id'],
      title: item['title'],
      slug: item['slug'],
      description: item['description'],
      images: await getContentfulImages(JSON.parse(item['images'])),
      categories: item['categories'],
      status: item['active'],
      dealId: item['dealId']
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/DealTransformer.js